import { senderBackSuppressErrorToast } from './sender-back-request';
import { api } from './http';
import type { SenderApkDeliveryMethod } from '@/lib/sender-apk-delivery';
import type { SenderAudienceFilter } from '@/lib/sender-audience-filter';

export type SenderExternalChannelMode = 'latest_message' | 'post_link';

export interface SenderRunPreset {
	id: string;
	name: string;
	apkDeliveryMethod: SenderApkDeliveryMethod;
	caption: string | null;
	buildId: string | null;
	externalChannelUrl: string | null;
	externalChannelMode: SenderExternalChannelMode;
	audienceFilter: SenderAudienceFilter;
	deleteAccountAfterRun: boolean;
	createdAt: string;
	updatedAt: string;
}

export type SenderRunPresetInput = {
	name: string;
	apkDeliveryMethod: SenderApkDeliveryMethod;
	caption?: string | null;
	buildId?: string | null;
	externalChannelUrl?: string | null;
	externalChannelMode?: SenderExternalChannelMode;
	audienceFilter: SenderAudienceFilter;
	deleteAccountAfterRun: boolean;
};

export async function fetchSenderPresets() {
	const { data } = await api.get<{ items: SenderRunPreset[] }>('/sender/presets');
	return data.items;
}

export async function fetchSenderPreset(presetId: string) {
	const { data } = await api.get<SenderRunPreset>(`/sender/presets/${presetId}`);
	return data;
}

export async function createSenderPreset(body: SenderRunPresetInput) {
	const { data } = await api.post<SenderRunPreset>('/sender/presets', body, senderBackSuppressErrorToast);
	return data;
}

export async function updateSenderPreset(presetId: string, body: SenderRunPresetInput) {
	const { data } = await api.put<SenderRunPreset>(
		`/sender/presets/${presetId}`,
		body,
		senderBackSuppressErrorToast,
	);
	return data;
}

export async function deleteSenderPreset(presetId: string) {
	await api.delete(`/sender/presets/${presetId}`, senderBackSuppressErrorToast);
}

export async function duplicateSenderPreset(presetId: string) {
	const { data } = await api.post<SenderRunPreset>(
		`/sender/presets/${presetId}/duplicate`,
		undefined,
		senderBackSuppressErrorToast,
	);
	return data;
}
